// extracted by mini-css-extract-plugin
module.exports = {"MyPets":"styles_MyPets__3DWNt"};